<template>
  <div>
    <img v-if="end.img" class="end-image" :src="getImgUrl(end.img)" />
    <div class="text-area">
      <h3>{{ getResult(points).title }}</h3>
      <custom-paragraph
        class="end-text"
        :text="getResult(points).text"
        :link="getResult(points).link"
      />
      <p class="end-text">Tulos: {{ points + "/" + questions.length }}</p>
      <p class="end-text">{{ end.text }}</p>
      <div class="button-area">
        <!--<custom-button
          :text="'Osallistu Wolt-lahjakorttien arvontaan'"
          @click="finish"
        />-->
        <a class="restart-link" href="javascript:;" @click="$emit('restart')"
          >Tee uudestaan</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import Config from "../config";
//import CustomButton from "./CustomButton.vue";
import CustomParagraph from "./CustomParagraph.vue";

export default {
  props: ["points", "url"],
  components: { /*CustomButton,*/ CustomParagraph },
  data() {
    return {
      end: Config.end,
      questions: Config.questions,
      results: Config.results,
    };
  },
  methods: {
    getImgUrl(img) {
      return require("../assets/images/" + img);
    },
    getResult(points) {
      return this.results.find((result) => result.pointRange.includes(points));
    },
    finish() {
      window.open(this.url, "_blank");
    },
  },
};
</script>

<style scoped>
.end-image {
  width: 100%;
  object-fit: contain;
}

.text-area {
  padding: 30px 40px;
}

.end-text {
  color: var(--quiz-text-color);
  margin: 25px 0;
}

.button-area {
  text-align: center;
  margin-top: 25px;
}

.restart-link {
  display: block;
  margin-top: 16px;
}
</style>
